/**
 * Migrations: one-off data updates that ship with sf-api. sf-api lists the ones in the code it
 * runs, runs them in the background and checks every rule again (dry run first, one at a time).
 */

/** Permission for every /admin/eng/migrations route on sf-api, the menu entry and the page here. */
export const MIGRATIONS_PERMISSION = 'eng:migrations';

/** Refine resource for the menu (App.tsx and the access test share it). */
export const MIGRATIONS_RESOURCE = {
  name: 'eng-migrations',
  list: '/eng/migrations',
} as const;

export const MIGRATIONS_PATH = '/eng/migrations';

/** How often the list is read again while a run is in progress. */
export const MIGRATIONS_POLL_MS = 5000;
/** How many past runs the history drawer shows per page. */
export const MIGRATION_RUNS_LIMIT = 20;

export const ticketUrl = (ticket: string) =>
  `https://servefirst.atlassian.net/browse/${encodeURIComponent(ticket)}`;

export type MigrationStatus = 'pending' | 'done';
export type RunMode = 'dry_run' | 'apply';
export type RunState = 'running' | 'succeeded' | 'failed' | 'stopped';

export const MODE_LABELS: Record<RunMode, string> = {
  dry_run: 'Dry run',
  apply: 'Run',
};
export const modeLabel = (mode: string) => MODE_LABELS[mode as RunMode] ?? mode;

export const RUN_STATE_LABELS: Record<RunState, { label: string; color: string }> = {
  running: { label: 'Running', color: 'processing' },
  succeeded: { label: 'Succeeded', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
  stopped: { label: 'Stopped', color: 'warning' },
};

/** Clear messages for sf-api's refusal codes; anything else shows the server's own message. */
export const CONFLICT_MESSAGES: Record<string, string> = {
  MIGRATION_RUNNING:
    'Another migration is running on this environment. Wait for it to finish, then try again.',
  DRY_RUN_REQUIRED:
    'Dry run this migration first. A real run needs a finished dry run of the same version.',
  MIGRATIONS_UNAVAILABLE: "Migrations can't start right now. Try again in a minute.",
};
